import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

export const getEmployerDossier = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerDossier", dossierId],
    queryFn: (): Promise<Dossier> => {
      return fetchWithAuth<Dossier>("getEmployerDossier", dossierId);
    },
    enabled: isQueryEnabled(options),
  });
};
